<template>
    <div class="route">
        <div class="route1" v-if="bindData">
            <div class="route_one" :class="{active:$route.query.columnId == v.cid}" @click="goto(v.url)" v-for="(v,j) in bindData" v-if="j<(bindData.length-1)">{{v.name}}
                <div class="b"></div>
            </div>
            <div class="route_one" :class="{active:$route.query.columnId == bindData[bindData.length-1].cid}" @click="goto(bindData[bindData.length-1].url)">{{bindData[bindData.length-1].name}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "route",
        data() {
            return {
            }
        },
        created() {
         console.log( this.bindData,"newBind")
        },
        props:{
            bindData:{
                type:Array,
                default:function (value) {
                    return value
                }
            }
        },
        watch:{
            bindData:function (newValue) {
                console.log(newValue,"new")
            }
        },
        components: {
        },
        methods: {
            goto(url){
                location.href = url;
            }
        },
    }

</script>

<style lang="less" scoped>
    .route{
        background: rgb(13,174,236);
        .route1{
            display: flex;
            height: 50px;
            // width: 1200px;
            margin: 0 auto;
            align-items: center;
            .route_one{
                height: 50px;
                line-height: 50px;
                font-size:18px;
                color: white;
                width: 170px;
                text-align: center;
                position: relative;
                .b{
                    width: 1px;
                    background: white;
                    height: 20px;
                    position: absolute;
                    right:0;
                    top:15px;

                }
                .route_two{
                    height: 50px;
                    width: 510px;
                    background: rgb(255,153,0);
                    display: none;
                    >div{
                        height: 30px;

                        font-size: 14px;
                        line-height: 30px;
                        width: 33%;
                    }
                    >div:hover{
                        background: rgb(255,173,51);
                    }


                }
            }
            .route_one:hover{
                background: rgb(255,153,0);
                .route_two{
                    display: flex;
                    align-items: center;
                }
            }
            .active{
                background: rgb(255,153,0);
                .route_two{
                    display: flex;
                    align-items: center;
                }
            }

        }



    }
</style>
